import { createMask } from "imask";

export const getCurrencyMask = () => {

    return createMask({
        mask: 'num',
        blocks: {
            num: {
                mask: Number,
                thousandsSeparator: ' ',
                radix: ',',
                mapToRadix: ['.'],
                normalizeZeros: false
            }
        }
    });
}
